import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getGroupChargeInvoices = payload =>
  call(websocketFetch, 'get_group_charge_invoices', payload);
